var map = {
	"./a1.mp4": "3a1a",
	"./a2.mp4": "715d",
	"./a3.mp4": "d935",
	"./a4.mp4": "76d2",
	"./a5.mp4": "0e6e",
	"./exchange/video1_1.mp4": "cbd6",
	"./exchange/video1_2.mp4": "91d0",
	"./exchange/video2.mp4": "1d40",
	"./hotel/video1.mp4": "1197",
	"./hotel/video2.mp4": "3a70",
	"./hotel/video3.mp4": "bb45",
	"./real/video1.mp4": "b6f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a67c";